const mobileRoutes = new Set([
    '/store',
    '/checkout',
    '/leaderboards',
    '/profile',
    '/replay',
    '/about',
    '/values-examples',
    '/values',
    '/catan-rules',
    '/community',
    '/faq',
    '/privacy-policy',
    '/careers',
    '/terms',
    '/refund-policy',
    '/press-kit',
    '/championship2025',
    '/championship2026-form-application',
    '/championship2026-form-announcement',
    '/championship2026-form-result',
    '/championship2026',
])

function extractLastSegment(pathname: string): string {
    const lastSlash = pathname.lastIndexOf('/')
    return lastSlash != -1 ? pathname.substring(lastSlash) : pathname
}

export function matchMobileRoute(pathname: string): string | undefined {
    const route = extractLastSegment(pathname)
    if(mobileRoutes.has(route)) return route
    return undefined
}
